module.exports = __webpack_public_path__ + "img/area-add-1-01.2d45fe2.jpg";